import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, FormGroup, FormControl, ControlLabel, InputGroup, Glyphicon } from 'react-bootstrap';

class LogbookSignatureModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      showPassword: false,
      errors: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.toggleShowPassword = this.toggleShowPassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  toggleShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  validateEmail(email) {
    // Expressão regular básica para validar e‑mail
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, password } = this.state;
    let errors = {};

    if (!email) {
      errors.email = "Email is required";
    } else if (!this.validateEmail(email)) {
      errors.email = "Invalid email format";
    }
    if (!password) {
      errors.password = "Password is required";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    // Chama o callback do pai enviando as credenciais
    if (this.props.onSubmit) {
      this.props.onSubmit({ email, password });
    }
    // Limpa o formulário e fecha o modal
    this.setState({ email: '', password: '', errors: {}, showPassword: false });
    this.props.onHide();
  }

  render() {
    const { show, onHide, title, subtitle, confirmation } = this.props;
    const { email, password, showPassword, errors } = this.state;

    return (
      <Modal show={show} onHide={onHide} aria-labelledby="logbook-signature-modal-title">
        <Modal.Header closeButton>
          <Modal.Title id="logbook-signature-modal-title">{title}</Modal.Title>
          <hr />
          {subtitle && <p>{subtitle}</p>}
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <FormGroup controlId="formEmail" validationState={errors.email ? 'error' : null}>
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="email"
                name="email"
                value={email}
                placeholder="Informe seu email do Logbook"
                onChange={this.handleChange}
              />
              {errors.email && <span className="help-block" style={{ color: 'red' }}>{errors.email}</span>}
            </FormGroup>
            <FormGroup controlId="formPassword" validationState={errors.password ? 'error' : null}>
              <ControlLabel>Senha</ControlLabel>
              <InputGroup>
                <FormControl
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  placeholder="Informe sua senha do Logbook"
                  onChange={this.handleChange}
                />
                <InputGroup.Button>
                  <Button type="button" onClick={this.toggleShowPassword}>
                    <Glyphicon glyph={showPassword ? "eye-close" : "eye-open"} />
                  </Button>
                </InputGroup.Button>
              </InputGroup>
              {errors.password && <span className="help-block" style={{ color: 'red' }}>{errors.password}</span>}
            </FormGroup>
            <hr />
            <Button type="submit" bsStyle="primary" block>{confirmation}</Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={onHide}>Cancelar</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

LogbookSignatureModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  confirmation: PropTypes.string
};

LogbookSignatureModal.defaultProps = {
  title: "Tem certeza que deseja integrar com o Logbook App?",
  subtitle: "Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.",
  confirmation: "Confirmo que estou ciente e desejo prosseguir com a assinatura"
};

export default LogbookSignatureModal;


// WEBPACK FOOTER //
// ./src/Components/LogbookAppIntegration/LogbookSignatureModal.js